import fallback from '@/data/valueChain/starlinkDashboard.json';

export type DashboardStatKind = 'printed' | 'independent' | 'company_report' | 'hole';

export type DashboardStat = {
  label: string;
  value: string;
  kind: DashboardStatKind;
};

export type DashboardRow = {
  label: string;
  value: string;
};

export type DashboardBucket = {
  id: string;
  title: string;
  why: string;
  ok: boolean;
  live: boolean;
  source: string;
  landing?: string | null;
  stats: DashboardStat[];
  rows: DashboardRow[];
  note: string;
};

export type StarlinkDashboardPayload = {
  as_of: string;
  printed_sats: number;
  printed_markets: number;
  caveat: string;
  buckets: DashboardBucket[];
  ok_count: number;
  live_count: number;
  live?: boolean;
};

export const DASHBOARD_FALLBACK = fallback as StarlinkDashboardPayload;

export function bucketById(
  payload: StarlinkDashboardPayload,
  id: string,
): DashboardBucket | undefined {
  return payload.buckets.find((bucket) => bucket.id === id);
}
